<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="mkt-ops -main-font bookprice-dialog-compare-customer"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title style="padding-left: 40px;">Add Filters</md-dialog-title>

      <div class="dialog-content">
        <div class="md-layout -body">
          <div
            class="md-layout-item md-size-100"
            style="font-weight: bold; font-size: 14px; color: #727272; margin-bottom: 15px;"
          >
            Another book code for compare
          </div>

          <div class="md-layout-item md-size-100 mb10 size98">
            <multiselect
              v-model="selectedCompareCus1"
              id="compareCus1"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'bottom'"
              :options="optionsCompareCustomer"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="onSelect"
              @close="updateValueAction"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.id }} : {{ option.label }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'cus1')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="md-layout-item md-size-100 mb10 size98">
            <multiselect
              v-model="selectedCompareCus2"
              id="compareCus2"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'bottom'"
              :options="optionsCompareCustomer"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="onSelect"
              @close="updateValueAction"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.id }} : {{ option.label }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'cus2')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="md-layout-item md-size-100 mb10 size98">
            <multiselect
              v-model="selectedCompareCus3"
              id="compareCus3"
              label="label"
              track-by="id"
              placeholder="Search Book Code..."
              :open-direction="'bottom'"
              :options="optionsCompareCustomer"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelCustomer"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="onSelect"
              @close="updateValueAction"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.id }} : {{ option.label }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'cus3')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <md-dialog-actions>
        <md-button class="-cancel" @click="onClickCancel()">CANCEL</md-button>
        <md-button class="-confirm" @click="onClickAddClose()"
          >ADD & CLOSE</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import DialogConfirm from "./../../shared/dialog-confirm";

export default {
  name: "dialog-compare-customer",

  components: {
    DialogConfirm
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    customer: {
      type: Array,
      required: true
    },
    bookcode: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      // dataCompareCustomer: [],
      optionsCompareCustomer: [],
      selectedCompareCus1: [],
      selectedCompareCus2: [],
      selectedCompareCus3: [],
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      checkEvent: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      contentSnackbar: "",
      selectedValueCus: false
    };
  },

  watch: {
    show() {
      if (this.show) {
        // this.dataCompareCustomer = JSON.parse(JSON.stringify(this.customer));
        this.optionsCompareCustomer = this.customer;

        this.selectedCompareCus1 = [];
        this.selectedCompareCus2 = [];
        this.selectedCompareCus3 = [];
        if (this.bookcode && this.bookcode.length > 0) {
          for (let i = 0; i < this.bookcode.length; i++) {
            if (i === 0) {
              this.selectedCompareCus1 =
                this.bookcode[i].id === undefined ? [] : this.bookcode[i];
            } else if (i === 1) {
              this.selectedCompareCus2 =
                this.bookcode[i].id === undefined ? [] : this.bookcode[i];
            } else if (i === 2) {
              this.selectedCompareCus3 =
                this.bookcode[i].id === undefined ? [] : this.bookcode[i];
            }

            let key = this.optionsCompareCustomer.findIndex(item => {
              return this.bookcode[i].id === item.id;
            });
            if (key > -1) {
              this.optionsCompareCustomer.splice(key, 1);
            }
          }
        }
      }
    }
  },

  methods: {
    customLabelCustomer({ id, label }) {
      return `${id} : ${label}`;
    },
    onSelect(data) {
      let key = this.optionsCompareCustomer.findIndex(item => {
        return data.id === item.id;
      });

      if (key > -1) {
        this.optionsCompareCustomer.splice(key, 1);
      }
      this.selectedValueCus = true;
    },
    updateValueAction(value) {
      if (this.selectedValueCus === true && value !== null) {
        let key = this.optionsCompareCustomer.findIndex(item => {
          return value.id === item.id;
        });

        if (key === -1) {
          this.optionsCompareCustomer.push(value);
          this.optionsCompareCustomer.sort((a, b) => (a.id > b.id ? 1 : -1));
        }
      }
      this.selectedValueCus = false;
    },
    clearAll(item, type) {
      if (type == "cus1") {
        this.selectedCompareCus1 = [];
      } else if (type == "cus2") {
        this.selectedCompareCus2 = [];
      } else if (type == "cus3") {
        this.selectedCompareCus3 = [];
      }
      this.optionsCompareCustomer.push(item);
      this.optionsCompareCustomer.sort((a, b) => (a.id > b.id ? 1 : -1));
    },
    onClickCancel() {
      this.checkEvent = "cancel";
      this.contentDialog = "Are you sure you want to cancel ?";
      this.showDialogConfirm = true;
    },
    onClickAddClose() {
      if (
        (this.selectedCompareCus1.id !== undefined &&
          this.selectedCompareCus2.id !== undefined &&
          this.selectedCompareCus1.id === this.selectedCompareCus2.id) ||
        (this.selectedCompareCus1.id !== undefined &&
          this.selectedCompareCus3.id !== undefined &&
          this.selectedCompareCus1.id === this.selectedCompareCus3.id) ||
        (this.selectedCompareCus2.id !== undefined &&
          this.selectedCompareCus3.id !== undefined &&
          this.selectedCompareCus2.id === this.selectedCompareCus3.id)
      ) {
        this.contentSnackbar = "You have selected the same set of data.";
        this.showSnackbar = true;
        return;
      }

      this.checkEvent = "addclose";
      this.contentDialog = "Are you sure you want to add and close ?";
      this.showDialogConfirm = true;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkEvent === "cancel") {
        this.$emit("cancel");
      } else if (this.checkEvent === "addclose") {
        // let objCustomer = {};
        // let customer = [];
        // let customerLabel = [];
        // if (this.selectedCompareCus1.id !== undefined) {
        //   customer.push(this.selectedCompareCus1.id);
        //   customerLabel.push(this.selectedCompareCus1.label);
        // }
        // if (this.selectedCompareCus2.id !== undefined) {
        //   customer.push(this.selectedCompareCus2.id);
        //   customerLabel.push(this.selectedCompareCus2.label);
        // }
        // if (this.selectedCompareCus3.id !== undefined) {
        //   customer.push(this.selectedCompareCus3.id);
        //   customerLabel.push(this.selectedCompareCus3.label);
        // }

        // objCustomer["customer"] = customer;
        // objCustomer["customerLabel"] = customerLabel;
        // this.$emit("addclose", objCustomer);
        let customerComp = [];
        if (
          this.selectedCompareCus1 &&
          this.selectedCompareCus1.id !== undefined
        ) {
          customerComp.push(this.selectedCompareCus1);
        }
        if (
          this.selectedCompareCus2 &&
          this.selectedCompareCus2.id !== undefined
        ) {
          customerComp.push(this.selectedCompareCus2);
        }
        if (
          this.selectedCompareCus3 &&
          this.selectedCompareCus3.id !== undefined
        ) {
          customerComp.push(this.selectedCompareCus3);
        }
        this.$emit("addclose", customerComp);
      }
      this.showDialogConfirm = false;
    }
  }
};
</script>

<style lang="scss">
.bookprice-dialog-compare-customer {
  width: 35%;
  height: 60%;
  transform: unset !important;
  top: 20% !important;
  left: 35% !important;
  font-weight: 400 !important;

  .dialog-content {
    .-body {
      display: block;
      overflow-y: scroll;
      height: calc(60vmin - 125px);
      padding-left: 10px;

      .multiselect {
        margin-bottom: 10px;
      }

      .md-layout-item.size98 {
        min-width: 98% !important;
        max-width: 98% !important;
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
  }
}
</style>